import { Form } from 'antd';
import type { FC } from 'react';
import EditAddressForm from './EditAddressForm';
import './index.less';

type EditAddressModalProps = {
  visible?: boolean;
  loading?: boolean;
  currentAddress?: any;
  onSubmit?: (...args: any) => void;
  onCancel?: () => void;
};

const EditAddressModal: FC<EditAddressModalProps> = ({
  // visible,
  // loading,
  currentAddress,
  onSubmit,
  onCancel,
}) => {
  const [form] = Form.useForm();

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit?.(values);
    } catch (error) {}
  };

  return (
    <EditAddressForm
      form={form}
      handleSubmit={handleSubmit}
      onCancel={onCancel}
      currentAddress={currentAddress}
    />
  );
};

export default EditAddressModal;
